import { schema } from 'normalizr';

const collectionAttributeSchema = new schema.Entity('collectionAttributes');

export default collectionAttributeSchema;
